import React from "react";
import { BadgeCheck } from "lucide-react";

const STANDARDS = [
    {
        code: "ISO 20700",
        name: "Management Consulting Services",
        desc: "International guideline for the delivery of professional, transparent and ethical consulting engagements.",
    },
    {
        code: "Six Sigma",
        name: "Certified Black Belt",
        desc: "Statistical, process-driven improvement to eliminate defects and unlock measurable operational performance.",
    },
    {
        code: "Prosci®",
        name: "Change Management",
        desc: "ADKAR-based, people-centred change adoption — the global benchmark for sustainable transformation.",
    },
    {
        code: "PMI® PMP",
        name: "Project Management Professional",
        desc: "Discipline, governance and predictability for programmes that must land — on scope, time and budget.",
    },
    {
        code: "Vested®",
        name: "Outcome-Based Sourcing",
        desc: "University of Tennessee’s shared-value model for partnerships aligned on mutually desired outcomes.",
    },
    {
        code: "COPC®",
        name: "Customer Experience Standard",
        desc: "The global standard for high-performance customer operations, service journeys and contact centres.",
    },
];

export default function Standards() {
    return (
        <section
            id="standards"
            data-testid="standards-section"
            className="relative py-24 md:py-32 bg-bpo-ink text-white overflow-hidden"
        >
            <div
                aria-hidden
                className="absolute -top-40 right-0 w-[500px] h-[500px] rounded-full pointer-events-none"
                style={{
                    background:
                        "radial-gradient(closest-side, rgba(45,212,212,0.25), transparent 70%)",
                }}
            />
            <div className="relative max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
                    <div className="lg:col-span-7">
                        <span className="eyebrow text-bpo-cyan">
                            Certifications & Standards
                        </span>
                        <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
                            Rigour you can verify.
                            <span className="block text-bpo-cyan">
                                Outcomes you can measure.
                            </span>
                        </h2>
                    </div>
                    <div className="lg:col-span-5">
                        <p className="text-base md:text-lg text-white/75 leading-relaxed">
                            Every recommendation we make traces back to a
                            recognised global standard — so accountability is
                            built in, not bolted on.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {STANDARDS.map((s) => (
                        <article
                            key={s.code}
                            data-testid={`standard-${s.code.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            className="group rounded-2xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.06] p-7 transition-all"
                        >
                            <div className="flex items-center gap-3 mb-5">
                                <BadgeCheck className="h-5 w-5 text-bpo-cyan" />
                                <span className="font-display text-lg font-extrabold tracking-tight text-white">
                                    {s.code}
                                </span>
                            </div>
                            <h3 className="font-display text-xl font-bold tracking-tight text-white leading-tight">
                                {s.name}
                            </h3>
                            <p className="mt-3 text-sm text-white/70 leading-relaxed">
                                {s.desc}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
